import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Switch from "@material-ui/core/Switch";
import HomeIcon from "@material-ui/icons/HomeRounded";
import BusinessIcon from "@material-ui/icons/BusinessRounded";
import NotInterestedIcon from "@material-ui/icons/NotInterestedRounded";
import Radio from "@material-ui/core/Radio";
import AllIcon from "mdi-material-ui/HomeCity";
import VipIcon from "mdi-material-ui/AccountStar";
import PatrolIcon from "mdi-material-ui/CarConnected";

import useIpsExclusive from "../../../hooks/useIpsExclusive";
import { PropertyComponent } from "../../Markers/Property";
import * as colors from "../../../styles/colors";
import { initialState } from "../../../store/reducers/mapFilter";
import * as constants from "../../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    margin: "0 auto",
    backgroundColor: theme.palette.background.paper,
  },
}));

const MapFilter = ({ isOpen, onClose, filter, onSave }) => {
  const classes = useStyles();

  const ipsExclusive = useIpsExclusive();

  const [noServiceChecked, setNoServiceChecked] = useState(filter.noService);
  const [lowPriorityChecked, setLowPriorityChecked] = useState(
    filter.lowPriority
  );
  const [mediumPriorityChecked, setMediumPriorityChecked] = useState(
    filter.mediumPriority
  );
  const [highPriorityChecked, setHighPriorityChecked] = useState(
    filter.highPriority
  );
  const [noVariant, setNoVariant] = useState(filter.noVariant);
  const [resVariant, setResVariant] = useState(filter.resVariant);
  const [comVariant, setComVariant] = useState(filter.comVariant);
  const [technologiesVariant, setTechnologiesVariant] = useState(
    filter.technologiesVariant
  );
  const [other, setOther] = useState(filter.other);

  const createFilter = () => ({
    noService: noServiceChecked,
    lowPriority: lowPriorityChecked,
    mediumPriority: mediumPriorityChecked,
    highPriority: highPriorityChecked,
    noVariant,
    resVariant,
    comVariant,
    technologiesVariant,
    other,
  });

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>Map Filter</DialogTitle>
        <DialogContent>
          <List className={classes.root}>
            <ListSubheader>{"Property Status"}</ListSubheader>
            <ListItem>
              <ListItemIcon>
                <PropertyComponent color={colors.markers.property.NO_SERVICE} />
              </ListItemIcon>
              <ListItemText primary="No service required" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setNoServiceChecked(!noServiceChecked)}
                  checked={noServiceChecked}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PropertyComponent
                  color={colors.markers.property.LOW_PRIORITY}
                />
              </ListItemIcon>
              <ListItemText primary="Low priority" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setLowPriorityChecked(!lowPriorityChecked)}
                  checked={lowPriorityChecked}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PropertyComponent
                  color={colors.markers.property.MEDIUM_PRIORITY}
                />
              </ListItemIcon>
              <ListItemText primary="Medium priority" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() =>
                    setMediumPriorityChecked(!mediumPriorityChecked)
                  }
                  checked={mediumPriorityChecked}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PropertyComponent
                  color={colors.markers.property.HIGH_PRIORITY}
                />
              </ListItemIcon>
              <ListItemText primary="High priority" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setHighPriorityChecked(!highPriorityChecked)}
                  checked={highPriorityChecked}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListSubheader>{"Property Variant"}</ListSubheader>
            <ListItem>
              <ListItemIcon>
                <NotInterestedIcon />
              </ListItemIcon>
              <ListItemText primary="Not assigned" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setNoVariant(!noVariant)}
                  checked={noVariant}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Residential" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setResVariant(!resVariant)}
                  checked={resVariant}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary="Commercial" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => setComVariant(!comVariant)}
                  checked={comVariant}
                />
              </ListItemSecondaryAction>
            </ListItem>
            {ipsExclusive && (
              <ListItem>
                <ListItemIcon />
                <ListItemText
                  primary={constants.property.variant.TECHNOLOGIES.text}
                />
                <ListItemSecondaryAction>
                  <Switch
                    edge="end"
                    onChange={() =>
                      setTechnologiesVariant(!technologiesVariant)
                    }
                    checked={technologiesVariant}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            )}
            <ListSubheader>Other</ListSubheader>
            <ListItem>
              <ListItemIcon>
                <AllIcon />
              </ListItemIcon>
              <ListItemText primary="All" />
              <ListItemSecondaryAction>
                <Radio
                  checked={other === "ALL"}
                  onChange={() => setOther("ALL")}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <VipIcon />
              </ListItemIcon>
              <ListItemText primary="VIP" />
              <ListItemSecondaryAction>
                <Radio
                  checked={other === "VIP"}
                  onChange={() => setOther("VIP")}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PatrolIcon />
              </ListItemIcon>
              <ListItemText primary="Patrol" />
              <ListItemSecondaryAction>
                <Radio
                  checked={other === "PATROL"}
                  onChange={() => setOther("PATROL")}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onSave(initialState);
              onClose();
            }}
            color="primary"
          >
            Default
          </Button>
          <Button
            onClick={() => {
              onSave(createFilter());
              onClose();
            }}
            color="primary"
          >
            Save
          </Button>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MapFilter;
